import script from "./GenderSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./GenderSelect.vue?vue&type=script&setup=true&lang=js"

import "./GenderSelect.vue?vue&type=style&index=0&id=169b07f2&lang=css"

const __exports__ = script;

export default __exports__